export default __webpack_public_path__ + "static/media/and-learn-functions-400x277.6e054ee3.jpg";